var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('del',{class:_vm.customClass},[_c('PriceText',{attrs:{"amount":_vm.amount,"currency":_vm.currency}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }